import { useEffect, useMemo, useState } from 'react'
import { debounce } from './debounce'

/** Значение, отстающее от `value` на паузу в `ms` после последнего изменения.
 *
 *  Ползунок остаётся мгновенным (он читает исходное значение), а всё тяжёлое —
 *  запрос к серверу и запись адресной строки — цепляется за отстающее. Вся
 *  логика схлопывания в `debounce`, здесь только привязка к жизни компонента. */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value)
  const push = useMemo(() => debounce<T>(setSettled, ms), [ms])

  useEffect(() => {
    push(value)
  }, [value, push])

  // Отложенный вызов после размонтирования — setState на мёртвом компоненте.
  useEffect(() => () => push.cancel(), [push])

  return settled
}
